module.exports = "/images/do.svg?2a92352adcee44dfa2078036811241ba";